const axios = require('axios').default;
// import { API_BASE_URL } from "./url.js";
// import { BRIDGE_URL } from "./url.js";
import { showProcessErrorMessage } from "../state/alertHelpers.js";
import store from '../state/store';
import router from '@/router/index';


async function prepareRequest(config, request, loading = false,showError = false) {
    store.commit('process/initProcessLoading',loading)
    const currentHubUrl = `https://${window.location.host}/api/redirect`
    // const currentHubUrlLocal = `http://${window.location.host}/api/redirect`
    let result = await axios.post(currentHubUrl,request,config)
        .catch(error => {
            if(!error.response){
                let errorTitle = "Hata Oluştu";
                let errorMessage = error.response ? error.response.data.message : error.message;
                if(error.response.status === 401){
                    errorTitle = "Oturumun Süresi Dolmuştur";
                    errorMessage = "Lütfen giriş yapınız"
                }
                if(showError){
                    showProcessErrorMessage({
                        title: errorTitle,
                        text: errorMessage,
                    });
                }

                return {
                    data:{
                        success:false,
                        message: errorMessage,
                    }
                };
            }
            else
            {
                let errorTitle = "Hata Oluştu";
                let errorMessage = error.response.data ? error.response.data.message : "";
                if(error.response.status === 401){
                    errorTitle = "Oturumun Süresi Dolmuştur";
                    errorMessage = "Lütfen giriş yapınız";
                    showProcessErrorMessage({
                        title: errorTitle,
                        text: errorMessage,
                    });
                    router.push({name: 'login'})
                }
                if(showError) {
                    showProcessErrorMessage({
                        title: errorTitle,
                        text: errorMessage,
                    }).then(() => {
                        if(error.response.status === 401){
                            router.push({name: 'login'})
                        }
                    });
                }
                return {
                    data:{
                        success:false,
                        message: error.response.data.message,
                    }
                };

            }

        })
        .finally(() => {
            store.commit('process/initProcessLoading',false)
        })
    return result;

}
function setParamsToURL(url, params, urlSegments = []) {
    let paramsStr = "";


    for (let key in params)
        paramsStr += "&" + key + "=" + params[key];

    paramsStr = paramsStr.substring(1);
    if (paramsStr != "")
        paramsStr = "?" + paramsStr;

    let segmentString = "";
    for(let i = 0; i < urlSegments.length; i++)
    {
        segmentString =segmentString +  "/" + urlSegments[i];
    }
    const DOMAIN_BASE_URL = `http://${localStorage.getItem("ipAddress")}:${localStorage.getItem("port")}/api`;
    return DOMAIN_BASE_URL + url + segmentString + paramsStr;
}




export { prepareRequest, setParamsToURL };
